class MovePianoRollPattern {
    constructor(track, pattern, startStep) {
        this.track = track;
        this.pattern = pattern;
        this.startStep = startStep;
    }

    execute() {
        this.pattern.startStep = this.startStep;
    }
}

export default MovePianoRollPattern;
